<div class="access-denied-container">
  <nz-result nzStatus="403" nzTitle="403 - Access Denied" nzSubTitle="Sorry, you do not have permission to access this application. Please contact your administrator if you believe this is an error.">
    <div nz-result-extra class="d-flex justify-content-center">
      <button nz-button nzType="primary" (click)="onLogout()">Back to Login</button>
    </div>
  </nz-result>
</div>

